export default __webpack_public_path__ + "static/media/snow2.3ed611e7.png";